export default function isUndefined(input) {
    return input === void 0;
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/utils/is-undefined.js